import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import { Spinner } from "../components/ui/Spinner";

/**
 * Admin-only route guard (PRD §5.5). Runs after auth: anon → /login, investor →
 * /. This is convenience only — the API 403 on /api/activity* is the real
 * boundary, so an investor never sees analytics data even if they reach a route.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();

  if (status === "loading") {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner className="h-8 w-8 text-brand-600" label="Loading" />
      </div>
    );
  }

  if (status === "anon") {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
